import { Injectable } from '@angular/core';
import { convertCamelCasesToSpaces } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor() { }

  exportToExcel(data: any[], fileName: string, headers = [], wscols = []) {
    let defaultFileName = `export_${new Date().getTime()}`
    const xmlContent = this.convertToXML(data, headers, wscols);
    const blob = new Blob([xmlContent], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName ? fileName : defaultFileName + '.xls';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  private convertToXML(data: any[], headers = [], wscols = []): string {
    const xmlHeader = '<?xml version="1.0"?>\n' +
      '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"\n' +
      '  xmlns:o="urn:schemas-microsoft-com:office:office"\n' +
      '  xmlns:x="urn:schemas-microsoft-com:office:excel"\n' +
      '  xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"\n' +
      '  xmlns:html="http://www.w3.org/TR/REC-html40">\n' +
      '<Worksheet ss:Name="Sheet1">\n<Table>\n';
      let xmlCols = ""
    let xmlData = '<Row>\n';
    if (headers.length != 0) {
      headers.forEach(header => {
        xmlData += `<Cell><Data ss:Type="String">${convertCamelCasesToSpaces(header)}</Data></Cell>\n`;
      });
    } else {
      // Extract headers from the first object in the data array
      const defaultHeaders = Object.keys(data[0]);
      defaultHeaders.forEach(header => {
        xmlData += `<Cell><Data ss:Type="String">${convertCamelCasesToSpaces(header)}</Data></Cell>\n`;
        if(wscols.length == 0){
          xmlCols += `<Column ss:Width="${header.length> 10 ? 100:80 }"/>\n`;
        }
      });
    }
    xmlData += '</Row>\n';

    data.forEach(row => {
      xmlData += '<Row>\n';
      Object.values(row).forEach(value => {
        xmlData += `<Cell><Data ss:Type="String">${value}</Data></Cell>\n`;
      });
      xmlData += '</Row>\n';
    });

    const xmlFooter = '</Table>\n</Worksheet>\n</Workbook>';
    wscols.forEach(col => {
      xmlCols += `<Column ss:Width="${col.wch}"/>\n`;
    });

    return xmlHeader +  xmlCols + xmlData + xmlFooter;
  }
}